export default __webpack_public_path__ + "static/media/No.3-4.bd8db1fd.jpg";